
angular.module('tf.directives')

    .directive('checkbox', function() {
        return {
            restrict: 'E',
            template: '<i ng-class="{\'fa-check-square-o\' : select, \'fa-square-o\' : !select}" class="fa tf-checkbox"></i>',
            replace: true,
            scope:{
                select:"="
            }
        };

    })

    .directive('visibility', function() {
        return {
            restrict: 'E',
            template: '<i ng-class="{\'fa fa-eye\' : select, \'fa fa-eye-slash\' : !select}"></i>',
            replace: true,
            scope:{
                select:"="
            }
        };
    });